// tslint:disable:no-bitwise
/**
 * A class for some code common between many tiling schemes. This isn't a full scheme in its own right so doesn't
 * implement the interface.
 *
 * One of the concrete implementations must be used, this is just a utility for common code.
 *
 * @see WebMercatorTilingScheme
 * @see GeographicTilingScheme
 * @see TilingScheme
 */
export class BaseTilingScheme {
    constructor(numRootTilesX, numRootTilesY) {
        this._numRootTilesX = numRootTilesX;
        this._numRootTilesY = numRootTilesY;
    }
    /**
     * @see TilingScheme.getNumberOfXTilesAtLevel
     */
    getNumberOfXTilesAtLevel(level) {
        return this._numRootTilesX << level;
    }
    /**
     * @see TilingScheme.getNumberOfYTilesAtLevel
     */
    getNumberOfYTilesAtLevel(level) {
        return this._numRootTilesY << level;
    }
}
